var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg1Link(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 133.86 52.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".svg-logo{fill:#5168c1;}.svg-logo,.cls-3{fill-rule:evenodd;}.cls-2,.cls-3{fill:#fff;}.cls-4{fill:#636569;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1link") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "svg-logo",
    d: "M94.69,52.84H26.42A26.42,26.42,0,0,1,0,26.42H0A26.42,26.42,0,0,1,26.42,0h94.7V26.42A26.42,26.42,0,0,1,94.69,52.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48.64,39.25V15.31h5.78V39.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M58.49,20V15.31h5.75V20Zm0,19.28V21.58h5.75V39.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M68.3,39.25V21.58H74V24a6,6,0,0,1,2.22-2.15,6.59,6.59,0,0,1,3.14-.71q3.11,0,4.49,1.56t1.39,5.06V39.25H79.42V30.36a9.39,9.39,0,0,0-.52-4A2.07,2.07,0,0,0,77,25.53a2.52,2.52,0,0,0-2.23,1,5.9,5.9,0,0,0-.7,3.24v9.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M89.1,39.25V15.31h5.69V27.66l5.33-6.08h6.79l-6.12,6.75,6.29,10.92h-6.42l-3.74-7-2.13,2.23v4.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M25.56,44.13A17.52,17.52,0,1,1,43.09,26.61,17.55,17.55,0,0,1,25.56,44.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg-logo",
    d: "M30.27,39V15H24.82a5.54,5.54,0,0,1-2,3.84,9.39,9.39,0,0,1-5,1.22v5h5.4V39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M133.86,3.94a4,4,0,1,1-4-3.94A4,4,0,0,1,133.86,3.94Zm-7.08,0a3,3,0,0,0,3.07,3.14,3,3,0,0,0,3-3.12,3,3,0,1,0-6.07,0ZM129.2,6h-.91V2.06a8.18,8.18,0,0,1,1.51-.12,2.43,2.43,0,0,1,1.37.29,1.09,1.09,0,0,1,.39.87,1,1,0,0,1-.82.91v0a1.14,1.14,0,0,1,.72,1,2.82,2.82,0,0,0,.29,1h-1a3.29,3.29,0,0,1-.31-1c-.07-.43-.31-.62-.81-.62h-.44Zm0-2.23h.43c.51,0,.91-.17.91-.58s-.26-.6-.84-.6a2.31,2.31,0,0,0-.5.05Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1Link);
export default __webpack_public_path__ + "static/media/1link.5071597dff0e8d30c4ed6cec724ea091.svg";
export { ForwardRef as ReactComponent };